import "../../../../src/content/noco-streaming/nocostreaming.scss";
import * as React from 'react';
export default {
  React
};